import env from '@tencent/vft-common/env';
import atom from '@tencent/vft-atom';

export * from './playVideo';

export const openUrl = (url: string) => {
  if (env.isApp) {
    atom.openUrl(url);
  } else {
    window.location.href = url;
  }
};

export const openProperty = () => {
  openUrl('//film.qq.com/weixin/v3/asset/index.html?header=0#award');
};
